import { customerListQuerySchema } from '@chukua/common';
import { useEffect, useState } from 'react';
import { listCustomers } from '../../../../customers/customers.api';
import type { FilterOption } from '../components/build-job-columns';

/**
 * The jobs list's customer filter (gitaumoses4/chukua#39) — a fixed first page of customers,
 * same "small bounded catalogue" idiom as `useComplianceDocumentTypeOptions`. Doesn't scale
 * past ~100 customers (see the plan's open question); a searchable dropdown is the fix if
 * that turns out to matter.
 */
export function useCustomerFilterOptions(): FilterOption[] {
  const [options, setOptions] = useState<FilterOption[]>([]);

  useEffect(() => {
    let cancelled = false;
    listCustomers(customerListQuerySchema.parse({ pageSize: 100 }))
      .then((page) => {
        if (!cancelled) setOptions(page.items.map((customer) => ({ value: customer.id, label: customer.name })));
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return options;
}
